import api from '@/core/apiclient'
import {actionTypes, mimeTypes, mutationTypes} from '@/core/constants'
import {DownloadUtils} from '@/core/utils'
const downloadUtils = new DownloadUtils()

export default {
    
    
    async [actionTypes.BUSCAR_PARAMETROS]({commit}, processo) {
        const {data} = await api.licitacao.buscarParametros(processo)
        commit(mutationTypes.SET_PARAMETROS, data)
    },
    
    async [actionTypes.VALIDAR_DOCUMENTO_VIRTUALIZADO](_context, codigo){
        const {data} = await api.validarDocumentoApi.validarDocumento(codigo)
        return {
            valido: data.ehDocumentoValido,
            idVirtualizado: data.documentoVirtualizadoId,
            arquivoSrc: data.arquivoSrc,
            dataHoraValidacao: data.dataHoraPesquisa,
            nome: data.nomeDocumento
        }
    },

    async [actionTypes.BAIXAR_DOCUMENTOS_VIRTUALIZADOS](_context, {id, nome}){
        const {data} = await api.validarDocumentoApi.baixarDocumentos(id)
        let blob = new Blob([data], {
            type: 'application/zip'
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nome ? nome : 'Documentos'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    async [actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO](_context, licitacaoId){
        const {data} = await api.licitacao.baixarAtaPublica(licitacaoId)
        const nomeArquivo = 'Relatorio_da_Ata.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.BUSCAR_LICITACOES_PUBLICAS](_context, {filtros, paginacao}){
        const {data} = await api.licitacao.buscarLicitacoesPublicas(filtros, paginacao)
        return data
    },
    
    async [actionTypes.BUSCAR_DADOS_GERAIS]({commit}, licitacaoId){
        const {data} = await api.licitacao.buscarDadosGeraisLicitacao(licitacaoId)
        commit(mutationTypes.SET_LICITACAO, data)
    },
    
    async [actionTypes.BUSCAR_ANEXOS_EDITAL](_context, licitacaoId){
        const {data} = await api.licitacao.buscarAnexosEdital(licitacaoId)
        return data
    },
    
    async [actionTypes.SOLICITAR_ESCLARECIMENTO_IMPUGNACAO](_context, payload){
        const {data} = await api.licitacao.solicitarEsclarecimentoImpugnacaoApi(payload)
        return data
    },

    async [actionTypes.VALIDAR_CODIGO_EMAIL](_context, codigo){
        const {data} = await api.licitacao.validarCodigoEmail(codigo)
        return data
    },

    async [actionTypes.BUSCAR_ACOMPANHAMENTO](_context, licitacaoId){
        const {data} = await api.licitacao.buscarAcompanhamentoApi(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_ACOMPANHAMENTO_DETALHE](_context, {licitacaoId, loteId}){
        const {data} = await api.licitacao.buscarAcompanhamentoDetalheApi(licitacaoId, loteId)
        return data
    },

    async [actionTypes.BUSCAR_FORNECEDORES_LOTE](_context, {licitacaoId, loteId}){
        const {data} = await api.licitacao.buscarFornecedoresLoteApi(licitacaoId, loteId)
        return data
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_VENCEDOR_LOTE](_context, {licitacaoId, loteId, fornecedorId}){
        const {data} = await api.licitacao.buscarDocumentosVencedorLoteApi(licitacaoId, loteId, fornecedorId)
        return data
    },

    async [actionTypes.BAIXAR_DOCUMENTO_VENCEDOR_LOTE](_context, {licitacaoId, loteId, tipoDocumento, fornecedorId, nomeArquivo, headers}){
        const {data} = await api.licitacao.baixarDocumentoVencedorLoteApi(licitacaoId, loteId, tipoDocumento, fornecedorId, headers)

        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf.valor)
    },
    
    async [actionTypes.BUSCAR_ESCLARECIMENTO_IMPUGNACAO](_context, licitacaoId){
        const {data} = await api.licitacao.buscarEsclarecimentosImpugnacoes(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_RESPOSTAS_ESCLARECIMENTO_IMPUGNACAO](context, esclarecimentoImpugnacaoId){
        const {data} = await api.licitacao.buscarRespostasEsclarecimentoImpugnacao(esclarecimentoImpugnacaoId)
        return data
    },

    async [actionTypes.BUSCAR_ESTADOS_EFORNECEDOR](){
        const {data} = await api.efornecedor.buscarEstados()
        return data
    },

    async [actionTypes.BUSCAR_MUNICIPIOS_POR_ESTADO](_context, estadoSigla){
        const {data} = await api.licitacao.buscarMunicipios(estadoSigla)
        return data
    },

    async [actionTypes.BUSCAR_PROCESSOS_PUBLICADOS](_context, paginacao){
        const {data} = await api.licitacao.buscarProcessos(paginacao)
        return data
    },

    async [actionTypes.BUSCAR_PROCESSO_LICITACAO](_context, processoId){
        const {data} = await api.licitacao.buscarUnicoProcessoLicitacao(processoId)
        return data
    },

    async [actionTypes.BUSCAR_LOTES_PAGINA_INTERNA](_context, {processoId, paginacao}){
        const {data} = await api.licitacao.buscarLotesPaginaInterna(processoId, paginacao)
        return data
    },

    async [actionTypes.FLOWBEE.BAIXAR_ARQUIVO](context, { payload, headers }){
        const {data} = await api.licitacao.baixarArquivo(payload, headers)

        downloadUtils.baixarBlob(data, payload.nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.GERAR_XML_PROPOSTA_PRESENCIAL](_context, payload){
        const {data} = await api.licitacao.gerarXMLPropostaPresencial(payload)

        downloadUtils.baixarBlob(data, 'proposta.xml', mimeTypes.xml.valor)
    },

    async [actionTypes.BUSCAR_LISTAGEM_SIMULAR_PROPOSTA](_context, licitacaoId){
        const {data} = await api.licitacao.buscarListagemSimularProposta(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_IMAGENS_ITEM_BASE64](context, { itemId }) {
        const { data } = await api.licitacao.buscarImagensItemBase64(itemId)
        return data.imagens
    },

    async [actionTypes.BUSCAR_IMAGENS_LOTE_LICITACAO](context, { licitacaoId }) {
        const { data } = await api.licitacao.buscarImagensLoteLicitacao(licitacaoId)
        return data.imagensLote
    },

    async [actionTypes.BUSCAR_DADOS_GERAIS_CREDENCIAMENTO]({commit}, licitacaoId){
        const {data} = await api.credenciamento.buscarDadosGeraisCredenciamento(licitacaoId)
        commit(mutationTypes.SET_LICITACAO, data)
    },

    async [actionTypes.BUSCAR_ANEXOS_EDITAL_CREDENCIAMENTO](_context, licitacaoId){
        const {data} = await api.credenciamento.buscarAnexosEditalCredenciamento(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO](_context, licitacaoId){
        const {data} = await api.credenciamento.buscarEsclarecimentosImpugnacoesCredenciamento(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_RESULTADO_CREDENCIAMENTO_PUBLICO](_context, { licitacaoId, paginacao } = {}){
        const page = paginacao && paginacao.page ? paginacao.page : 1
        const size = paginacao && paginacao.size ? paginacao.size : 100
        const {data} = await api.credenciamento.buscarResultadoCredenciamentoPublico(licitacaoId, { page, size })
        return data
    },

    async [actionTypes.BAIXAR_DOCUMENTACAO_FORNECEDOR_CREDENCIAMENTO](_context, { licitacaoId, fornecedorId, nomeFornecedor }){
        const response = await api.credenciamento.baixarDocumentacaoFornecedorPublica(licitacaoId, fornecedorId)
        const data = response.data
        const dispo = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
        let nomeArquivo = nomeFornecedor ? `${nomeFornecedor}.zip` : 'documentacao.zip'
        if (dispo) {
            const match = dispo.match(/filename\s*=\s*([^;]+)/i)
            if (match && match[1]) {
                nomeArquivo = match[1].replace(/\"/g, '').trim()
            }
        }
        const blob = new Blob([data], { type: 'application/zip' })
        const link = document.createElement('a')
        link.setAttribute('type', 'hidden')
        link.href = window.URL.createObjectURL(blob)
        link.download = nomeArquivo
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },

    async [actionTypes.SOLICITAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO](_context, payload){
        const {data} = await api.credenciamento.solicitarEsclarecimentoImpugnacaoCredenciamentoApi(payload)
        return data
    },

    async [actionTypes.BUSCAR_ITENS_LOTES_CREDENCIAMENTO](_context, licitacaoId){
        const { data } = await api.credenciamento.buscarItensLotesCredenciamento(licitacaoId)
        return data
    },
}
